// Lightweight credits fetcher with in-memory caching to avoid duplicate calls
import { API_ENDPOINTS } from '../config/api';
import { isCookieAuthActive, getAuthHeaders } from '../utils/auth';

const CACHE_TTL_MS = 15000; // 15s cache
let cachedValue = null;
let cachedAt = 0;
let inFlight = null;

export const fetchCreditsCached = async () => {
  const now = Date.now();
  if (cachedValue !== null && now - cachedAt < CACHE_TTL_MS) {
    return cachedValue;
  }
  if (inFlight) return inFlight;

  // Need cookie auth or token auth
  if (!isCookieAuthActive() && !localStorage.getItem('auth_token')) {
    cachedValue = { totalCredits: 0 };
    cachedAt = now;
    return cachedValue;
  }

  const headers = getAuthHeaders();

  inFlight = fetch(API_ENDPOINTS.USERS.CREDITS, {
    method: 'GET',
    credentials: 'include',
    headers
  })
    .then(async (res) => {
      console.log('📡 Credits API response status:', res.status);
      if (!res.ok) {
        const errorText = await res.text();
        console.error('❌ Credits API error:', res.status, errorText);
        throw new Error(`Credits fetch failed: ${res.status}`);
      }
      const data = await res.json();
      console.log('✅ Credits API response data:', data);
      cachedValue = data || { totalCredits: 0 };
      cachedAt = Date.now();
      console.log('💾 Cached credits value:', cachedValue);
      return cachedValue;
    })
    .catch((err) => {
      // DO NOT cache errors - let them fail through so retry is possible
      console.error('❌ Credits fetch error - NOT caching:', err);
      // Return zero but don't cache it
      return { totalCredits: 0 };
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
};

export const clearCreditsCache = () => {
  cachedValue = null;
  cachedAt = 0;
};
